import { render } from "./aging-report-customer.vue?vue&type=template&id=380369f0"
import script from "./aging-report-customer.vue?vue&type=script&lang=js"
export * from "./aging-report-customer.vue?vue&type=script&lang=js"

import "./aging-report-customer.vue?vue&type=style&index=0&id=380369f0&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__